import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../global/AuthContext';
import '../../assets/css/container/main/Top.css';

// @ts-ignore
function Top({ onMenuClick }) {
	const navigate = useNavigate();
	const { logout } = useAuth();
	// const [isLoggedIn, setIsLoggedIn] = useState<boolean>(!!localStorage.getItem("accessToken"));

	const { user } = useAuth();
	const isLoggedIn = !!user;

	// 세로가 가로보다 크면 모바일, 아니면 데스크탑
	const [isMobile, setIsMobile] = useState<boolean>(window.innerHeight > window.innerWidth);

	const goMainWithType = (type: "recent" | "my" | "interest") => {
		navigate("/", {
			state: { initialType: type }
		});
	};

	// 로그인 상태 감지 (컴포넌트가 렌더링될 때마다 체크)
	// useEffect(() => {
	// 	// 페이지 진입 시 즉시 상태 확인
	// 	setIsLoggedIn(!!localStorage.getItem("accessToken"));
	//
	// 	const handleStorageChange = () => {
	// 		setIsLoggedIn(!!localStorage.getItem("accessToken"));
	// 	};
	//
	// 	// 커스텀 이벤트로 로그인 상태 변경 감지
	// 	const handleLoginChange = () => {
	// 		setIsLoggedIn(!!localStorage.getItem("accessToken"));
	// 	};
	//
	// 	window.addEventListener("storage", handleStorageChange);
	// 	window.addEventListener("loginStateChanged", handleLoginChange);
	//
	// 	return () => {
	// 		window.removeEventListener("storage", handleStorageChange);
	// 		window.removeEventListener("loginStateChanged", handleLoginChange);
	// 	};
	// }, []);

	// 화면 비율 감지 (세로 > 가로 = 모바일)
	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerHeight > window.innerWidth);
		};
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	// 준비중 메뉴 클릭 핸들러
	const handleComingSoon = (e: React.MouseEvent) => {
		e.preventDefault();
		alert("준비중입니다.");
	};

	// 모바일은 항상 기존 탑바
	if (isMobile) {
		return (
			<div className="Top mobile">
				<button className="menuBtn" onClick={onMenuClick}>
					☰
				</button>
			</div>
		);
	}

	// 데스크탑 - 비로그인
	if (!isLoggedIn) {
		return (
			<div className="Top desktop guest">
				<div className="top-left">
					<h2 className="logo" onClick={() => navigate("/")}>
						FactWeb
					</h2>
				</div>
				<div className="top-right">
                    <button className="nav-btn" onClick={() => navigate("/freeboard")}>자유게시판</button>
					<button className="nav-btn" onClick={() => navigate("/about")}>
						소개
					</button>
					<button className="nav-btn" onClick={() => navigate("/login")}>
						공지사항
					</button>
					<button className="login-btn" onClick={() => navigate("/login")}>
						로그인
					</button>
				</div>
			</div>
		);
	}

	// 데스크탑 - 로그인 (메뉴를 탑바에 표시)
	return (
		<div className="Top desktop logged-in">
			<div className="top-left">
				<h2 className="logo" onClick={() => goMainWithType("recent")}>
					FactWeb
				</h2>
			</div>
			<nav className="top-nav">
				<button
					className="nav-btn"
					onClick={() => goMainWithType("recent")}
				>
					메인 페이지
				</button>

				<button className="nav-btn" onClick={() => navigate("/myinfo")}>
					나의 정보
				</button>
				<button
					className="nav-btn"
					onClick={() => goMainWithType("my")}
				>
					나의 Fact
				</button>

				<button
					className="nav-btn"
					onClick={() => goMainWithType("interest")}
				>
					관심 Fact
				</button>

				<button className="nav-btn" onClick={handleComingSoon}>
					나의 Fact 통계
				</button>
				<button className="nav-btn" onClick={handleComingSoon}>
					나의 Fact Web
				</button>
				<div className="nav-divider"></div>
                <button className="nav-btn" onClick={() => navigate("/freeboard")}>자유게시판</button>
				<button className="nav-btn" onClick={() => navigate("/notices")}>
					공지사항
				</button>
				<button className="nav-btn" onClick={() => navigate("/about")}>
					About FactWeb
				</button>
				<button className="nav-btn logout-btn" onClick={logout}>
					로그아웃
				</button>
			</nav>
		</div>
	);
}

export default Top;
